export const Breakpoints = {
    values: { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200 }
};
//# sourceMappingURL=breakpoints.js.map